export const Otp = ({ list, inputRef, otp, otpHandler, inputFocus, otpValueFinal, setStep }) => (
  <>
    <div className="flex-col align-items-center justify-content-center">
      <div className="font-32 bold text-black p-tb-32">Verify your identity</div>
    </div>
    <div className="auth-form auth-signup justify-content-center">
      <div className="auth-items">
        <div className="auth-row">
          <span className="font-16">Enter the 4-digit code that sent to +1 (812) 234-5678</span>
        </div>
        <div className="auth-row input-otp w-260 p-tb-24 m-0auto">
          {list.map((x) => (
            <input
              key={x}
              /* eslint-disable-next-line no-return-assign */
              ref={(el) => (inputRef.current[x] = el)}
              /* eslint-disable-next-line jsx-a11y/no-autofocus */
              autoFocus={x === 0}
              value={otp[x]}
              onChange={otpHandler(x)}
              onKeyUp={(e) => inputFocus(e, x)}
              type="number"
              className={otpValueFinal.length !== 4 && "error"}
            />
          ))}
        </div>
        <div className="w-260">
          <span className={`auth-input-error ${otpValueFinal.length === 4 && "visibility-hidden"}`} id="error-otp">
            Wrong number of digits!
          </span>
        </div>
        <div className="auth-row w-260 p-tb-24 m-0auto">
          <div className={`btn-full ${otpValueFinal.length !== 4 && "disable"}`}>
            <span onClick={() => setStep("login")}>Continue</span>
          </div>
        </div>
        <div className="auth-row p-b-24">
          <div className="justify-content-center">
            <span>Didn’t get a text?</span>
            &#160;
            <span className="text-blue pointer text-underline">Send again</span>
          </div>
        </div>
        <div className="auth-row">
          <div className="justify-content-center">
            <span onClick={() => setStep("SignUp")} className="pointer">
              Back to sign up
            </span>
          </div>
        </div>
      </div>
    </div>
  </>
);
